module.exports = __webpack_public_path__ + "img/motorbikeFrontRightOutline.d03fe042.svg";